import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button, Tag } from 'antd';
import dayjs from 'dayjs';
import ChecklistType from "../../enums/ChecklistType";
import { nonEmpty } from "../../../../swzutils";
import HasPermissions from "../../../../containers/HasPermissions";
import { FilePdfOutlined } from "@ant-design/icons";
import GlobalConstants from "../../../../swzutils/GlobalConstants";
import API from "../../../../API";
import PaginatedFilterableTable, {} from "../../components/table/PaginatedFilterableTable";
const columns = [{
        title: 'Date',
        key: 'checkedOn',
        dataIndex: 'checkedOn',
        sorter: false,
        width: '8%',
        render: (text, record) => {
            return dayjs(record.createdAt).format("DD/MM/YYYY HH:mm");
        }
    }, {
        title: 'Type',
        dataIndex: 'checklistType',
        width: '2%',
        render: (text /*, record*/) => {
            return ChecklistType.fromString(text)?.renderTag();
        }
    }, {
        title: 'Rego',
        dataIndex: ['vehicleSummary', 'registration'],
        width: '7%'
    }, {
        title: 'Carrier',
        dataIndex: ['vehicleSummary', 'tenantName'],
        sorter: false,
        width: '12%'
    }, {
        title: 'Category',
        dataIndex: ['vehicleSummary', 'vehicleTypeCategory', 'description'],
        width: '10%',
        render: (text /*, record*/) => {
            return _jsx(Tag, { children: text });
        }
    }, {
        title: 'Type',
        dataIndex: ['vehicleSummary', 'vehicleTypeDescription'],
        width: '10%'
    }, {
        title: 'Odometer',
        dataIndex: 'odometer',
        width: '5%'
    }, {
        title: 'Driver',
        width: '10%',
        render: (text, record) => {
            return nonEmpty `${record.driverSummary.firstName} ${record.driverSummary.lastName}`;
        }
    }, {
        title: 'Faults',
        key: "hasFailures",
        width: '5%',
        render: (text, record) => {
            const color = record.hasFailures ? "#f2930c" : "#87d068";
            const message = record.hasFailures ? "FAILED" : "PASSED";
            return (_jsx(Tag, { color: color, children: message }));
        }
    }, {
        title: 'Urgent',
        dataIndex: 'urgent',
        key: 'urgency',
        width: '5%',
        render: (text /*, record*/) => {
            if (text) {
                return _jsx(Tag, { color: '#f24b03', children: "URGENT" });
            }
            return '';
        }
    }, {
        title: 'Consignment',
        dataIndex: ['consignment', 'consignmentRef'],
        width: '11%'
    }, {
        title: 'Action',
        key: 'action',
        width: '5%',
        render: (text, record) => (_jsx(HasPermissions, { permissions: ['admin:driverChecklist:view'], children: _jsx(Button, { target: GlobalConstants.PDF_WINDOW_TARGET_NAME, href: `${API.origin()}/admin/v1/driver-checklists/${record.id}/pdf`, icon: _jsx(FilePdfOutlined, {}), children: "Download" }) }))
    }];
const VehicleHireChecklistsTable = ({ vehicleHireId }) => {
    return (_jsx(PaginatedFilterableTable, { tableKey: 'vehicleHireDriverChecksTable', dataUri: `/admin/v1/vehicle-hires/${vehicleHireId}/driver-checklists`, columns: columns }));
};
export default VehicleHireChecklistsTable;
